import React from "react";
import "./AllReviews.scss";
import ReviewsAverage from "../../../components/ReviewsAverage/ReviewsAverage";
import BookingHeader from "../../../components/BookingHeader/BookingHeader";
import SingleReview from "../../../components/SingleReview/SingleReview";

const AllReviews = (props) => {
  return (
    <div className="AllReviews">
      <BookingHeader reviews onBack={props.handleNavBack} />
      <div className="reviewsWrapper">
        <ReviewsAverage rating={props.rating} />
        <SingleReview />
        <SingleReview />
        <SingleReview />
        <SingleReview />
        <SingleReview />
      </div>
    </div>
  );
};

export default AllReviews;
